// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1FeatureRequestsCreateSchema } from './v1/featureRequests/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const createFeatureRequestPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createFeatureRequestHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Feedback submitted successfully
 */
export const createFeatureRequest200Schema = z.unknown();

/**
 * @description Unauthorized
 */
export const createFeatureRequest401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation failed
 */
export const createFeatureRequest422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const createFeatureRequestMutationRequestSchema = z.lazy(() => v1FeatureRequestsCreateSchema);

export const createFeatureRequestMutationResponseSchema = z.lazy(() => createFeatureRequest200Schema);
